import { render, staticRenderFns } from "./CartInfoAddressCard.vue?vue&type=template&id=faf51ce4&"
import script from "./CartInfoAddressCard.vue?vue&type=script&lang=js&"
export * from "./CartInfoAddressCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports